import { RootStore } from '~/stores/root.store';
import { BaseImageController } from './base-image.controller';

export class ImageController extends BaseImageController {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        super({
            companyStore: rootStore.companyStore,
            userStore: rootStore.userStore,
            userService: rootStore.userService,
            imageService: rootStore.imageService,
            toastStore: rootStore.toastStore,
            companyService: rootStore.companyService
        });
        this.rootStore = rootStore;
    }
}
